import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { Grid, Row } from '@warrenbrasil/nebraska-web';

import { BuilderMatchMedia } from '../BuilderMatchMedia';

import TagRiskLevel from '../TagRiskLevel/TagRiskLevel.vue';
import { Product } from '../../types';
import { IProductRemove } from '../../services/types/models/IBffInvestments';

interface Props {
  instrument: Product;
  addProduct?: boolean;
  isSelected: boolean;
}

interface EmitEvents {
  (event: 'handle-instrument-click', { id }: IProductRemove): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CardInstrumentSelected',
  props: {
    instrument: null,
    addProduct: { type: Boolean },
    isSelected: { type: Boolean }
  },
  emits: ["handle-instrument-click"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'handle-instrument-click', { id }: IProductRemove): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  instrument: Product;
  addProduct?: boolean;
  isSelected: boolean;
}




const liquidityFormatted = computed(() => {
  return {
    label: props.instrument.withdrawPeriod.label,
    value: props.instrument.withdrawPeriod.value
  };
});

const benchmarkFormatted = computed(() => {
  return props.instrument.rentability ?? '-';
});

function onSelect() {
  emit('handle-instrument-click', {
    id: props.instrument.id
  });
}

return { __sfc: true,props, emit, liquidityFormatted, benchmarkFormatted, onSelect, Grid, Row, BuilderMatchMedia, TagRiskLevel }
}

})